import { Choices } from '../../../common/Choice';

export const CHOICES_BLOCK_TYPES: Choices = [
    { id: 'html', name: 'HTML', },
    { id: 'page_title', name: 'Page Title', },
    { id: 'section_title', name: 'Section Title', },
    { id: 'array_download', name: 'Download lists', },
    { id: 'array_contact', name: 'Contact lists', },
    { id: 'array_link', name: 'Link lists', },
    { id: 'image', name: 'Image', },
    { id: 'image_gallery', name: 'Image Gallery', },
];
